import { useQuery } from '@tanstack/react-query';
import {
  DeleteBlanketTrafficParams,
  GetBlanketTrafficResponse,
  UpdateBlanketTrafficParams,
  UpdateBlanketTrafficResponse
} from '@blisspointmedia/bpm-types/dist/LinearBlanketTraffic';
import { LinearBuyingLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';

const blanketTrafficQueryKey = (company: string) => ['blanketTraffic', company];

export const useBlanketTraffic = (
  company: string
): ReturnType<typeof useQuery<GetBlanketTrafficResponse>> =>
  useQuery({
    queryKey: blanketTrafficQueryKey(company),
    enabled: Boolean(company),
    queryFn: async (): Promise<GetBlanketTrafficResponse> =>
      awaitJSON<GetBlanketTrafficResponse>(
        await LinearBuyingLambdaFetch('/blanket_traffic', { params: { company } })
      )
  });

export const saveBlanketTraffic = async (
  params: UpdateBlanketTrafficParams
): Promise<UpdateBlanketTrafficResponse> =>
  awaitJSON<UpdateBlanketTrafficResponse>(
    await LinearBuyingLambdaFetch('/blanket_traffic', { method: 'POST', body: params })
  );

export const deleteBlanketTraffic = async (params: DeleteBlanketTrafficParams): Promise<void> => {
  await LinearBuyingLambdaFetch('/blanket_traffic/delete', { method: 'POST', body: params });
};
